import { render, staticRenderFns } from "./SellOrderDirect.vue?vue&type=template&id=195a32c2&scoped=true"
import script from "./SellOrderDirect.vue?vue&type=script&lang=js"
export * from "./SellOrderDirect.vue?vue&type=script&lang=js"
import style0 from "./SellOrderDirect.vue?vue&type=style&index=0&id=195a32c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195a32c2",
  null
  
)

export default component.exports